/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteTomoquestionnaireId } from '../fn/questionnaire/delete-tomoquestionnaire-id';
import { DeleteTomoquestionnaireId$Params } from '../fn/questionnaire/delete-tomoquestionnaire-id';
import { getTomoquestionnaire$Json } from '../fn/questionnaire/get-tomoquestionnaire-json';
import { GetTomoquestionnaire$Json$Params } from '../fn/questionnaire/get-tomoquestionnaire-json';
import { getTomoquestionnaire$Plain } from '../fn/questionnaire/get-tomoquestionnaire-plain';
import { GetTomoquestionnaire$Plain$Params } from '../fn/questionnaire/get-tomoquestionnaire-plain';
import { getTomoquestionnaireId$Json } from '../fn/questionnaire/get-tomoquestionnaire-id-json';
import { GetTomoquestionnaireId$Json$Params } from '../fn/questionnaire/get-tomoquestionnaire-id-json';
import { getTomoquestionnaireId$Plain } from '../fn/questionnaire/get-tomoquestionnaire-id-plain';
import { GetTomoquestionnaireId$Plain$Params } from '../fn/questionnaire/get-tomoquestionnaire-id-plain';
import { postTomoquestionnaire$Json } from '../fn/questionnaire/post-tomoquestionnaire-json';
import { PostTomoquestionnaire$Json$Params } from '../fn/questionnaire/post-tomoquestionnaire-json';
import { postTomoquestionnaire$Plain } from '../fn/questionnaire/post-tomoquestionnaire-plain';
import { PostTomoquestionnaire$Plain$Params } from '../fn/questionnaire/post-tomoquestionnaire-plain';
import { putTomoquestionnaireId$Json } from '../fn/questionnaire/put-tomoquestionnaire-id-json';
import { PutTomoquestionnaireId$Json$Params } from '../fn/questionnaire/put-tomoquestionnaire-id-json';
import { putTomoquestionnaireId$Plain } from '../fn/questionnaire/put-tomoquestionnaire-id-plain';
import { PutTomoquestionnaireId$Plain$Params } from '../fn/questionnaire/put-tomoquestionnaire-id-plain';
import { TomoQuestionnaire } from '../models/tomo-questionnaire';
import { TomoQuestionnairePagedResult } from '../models/tomo-questionnaire-paged-result';

@Injectable({ providedIn: 'root' })
export class QuestionnaireService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTomoquestionnaire()` */
  static readonly GetTomoquestionnairePath = '/tomoQuestionnaire';

  /**
   * Get all questionnaires.
   *
   * Get all questionnaires
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTomoquestionnaire$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTomoquestionnaire$Plain$Response(params?: GetTomoquestionnaire$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TomoQuestionnairePagedResult>> {
    const obs = getTomoquestionnaire$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all questionnaires.
   *
   * Get all questionnaires
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTomoquestionnaire$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTomoquestionnaire$Plain(params?: GetTomoquestionnaire$Plain$Params, context?: HttpContext): Observable<TomoQuestionnairePagedResult> {
    const resp = this.getTomoquestionnaire$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TomoQuestionnairePagedResult>): TomoQuestionnairePagedResult => r.body)
    );
  }

  /**
   * Get all questionnaires.
   *
   * Get all questionnaires
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTomoquestionnaire$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTomoquestionnaire$Json$Response(params?: GetTomoquestionnaire$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TomoQuestionnairePagedResult>> {
    const obs = getTomoquestionnaire$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all questionnaires.
   *
   * Get all questionnaires
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTomoquestionnaire$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTomoquestionnaire$Json(params?: GetTomoquestionnaire$Json$Params, context?: HttpContext): Observable<TomoQuestionnairePagedResult> {
    const resp = this.getTomoquestionnaire$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TomoQuestionnairePagedResult>): TomoQuestionnairePagedResult => r.body)
    );
  }

  /** Path part for operation `postTomoquestionnaire()` */
  static readonly PostTomoquestionnairePath = '/tomoQuestionnaire';

  /**
   * Create a new questionnaire.
   *
   * Create a new questionnaire
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postTomoquestionnaire$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postTomoquestionnaire$Plain$Response(params?: PostTomoquestionnaire$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TomoQuestionnaire>> {
    const obs = postTomoquestionnaire$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new questionnaire.
   *
   * Create a new questionnaire
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postTomoquestionnaire$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postTomoquestionnaire$Plain(params?: PostTomoquestionnaire$Plain$Params, context?: HttpContext): Observable<TomoQuestionnaire> {
    const resp = this.postTomoquestionnaire$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TomoQuestionnaire>): TomoQuestionnaire => r.body)
    );
  }

  /**
   * Create a new questionnaire.
   *
   * Create a new questionnaire
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postTomoquestionnaire$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postTomoquestionnaire$Json$Response(params?: PostTomoquestionnaire$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TomoQuestionnaire>> {
    const obs = postTomoquestionnaire$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new questionnaire.
   *
   * Create a new questionnaire
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postTomoquestionnaire$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postTomoquestionnaire$Json(params?: PostTomoquestionnaire$Json$Params, context?: HttpContext): Observable<TomoQuestionnaire> {
    const resp = this.postTomoquestionnaire$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TomoQuestionnaire>): TomoQuestionnaire => r.body)
    );
  }

  /** Path part for operation `getTomoquestionnaireId()` */
  static readonly GetTomoquestionnaireIdPath = '/tomoQuestionnaire/{id}';

  /**
   * Get a specific questionnaire by ID.
   *
   * Get a specific questionnaire by ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTomoquestionnaireId$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTomoquestionnaireId$Plain$Response(params: GetTomoquestionnaireId$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TomoQuestionnaire>> {
    const obs = getTomoquestionnaireId$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a specific questionnaire by ID.
   *
   * Get a specific questionnaire by ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTomoquestionnaireId$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTomoquestionnaireId$Plain(params: GetTomoquestionnaireId$Plain$Params, context?: HttpContext): Observable<TomoQuestionnaire> {
    const resp = this.getTomoquestionnaireId$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TomoQuestionnaire>): TomoQuestionnaire => r.body)
    );
  }

  /**
   * Get a specific questionnaire by ID.
   *
   * Get a specific questionnaire by ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTomoquestionnaireId$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTomoquestionnaireId$Json$Response(params: GetTomoquestionnaireId$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TomoQuestionnaire>> {
    const obs = getTomoquestionnaireId$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a specific questionnaire by ID.
   *
   * Get a specific questionnaire by ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTomoquestionnaireId$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTomoquestionnaireId$Json(params: GetTomoquestionnaireId$Json$Params, context?: HttpContext): Observable<TomoQuestionnaire> {
    const resp = this.getTomoquestionnaireId$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TomoQuestionnaire>): TomoQuestionnaire => r.body)
    );
  }

  /** Path part for operation `putTomoquestionnaireId()` */
  static readonly PutTomoquestionnaireIdPath = '/tomoQuestionnaire/{id}';

  /**
   * Update an existing questionnaire.
   *
   * Update an existing questionnaire
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putTomoquestionnaireId$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putTomoquestionnaireId$Plain$Response(params: PutTomoquestionnaireId$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TomoQuestionnaire>> {
    const obs = putTomoquestionnaireId$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update an existing questionnaire.
   *
   * Update an existing questionnaire
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putTomoquestionnaireId$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putTomoquestionnaireId$Plain(params: PutTomoquestionnaireId$Plain$Params, context?: HttpContext): Observable<TomoQuestionnaire> {
    const resp = this.putTomoquestionnaireId$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TomoQuestionnaire>): TomoQuestionnaire => r.body)
    );
  }

  /**
   * Update an existing questionnaire.
   *
   * Update an existing questionnaire
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putTomoquestionnaireId$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putTomoquestionnaireId$Json$Response(params: PutTomoquestionnaireId$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TomoQuestionnaire>> {
    const obs = putTomoquestionnaireId$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update an existing questionnaire.
   *
   * Update an existing questionnaire
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putTomoquestionnaireId$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putTomoquestionnaireId$Json(params: PutTomoquestionnaireId$Json$Params, context?: HttpContext): Observable<TomoQuestionnaire> {
    const resp = this.putTomoquestionnaireId$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TomoQuestionnaire>): TomoQuestionnaire => r.body)
    );
  }

  /** Path part for operation `deleteTomoquestionnaireId()` */
  static readonly DeleteTomoquestionnaireIdPath = '/tomoQuestionnaire/{id}';

  /**
   * Delete a questionnaire by ID.
   *
   * Delete a questionnaire by ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTomoquestionnaireId()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTomoquestionnaireId$Response(params: DeleteTomoquestionnaireId$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteTomoquestionnaireId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a questionnaire by ID.
   *
   * Delete a questionnaire by ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTomoquestionnaireId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTomoquestionnaireId(params: DeleteTomoquestionnaireId$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteTomoquestionnaireId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
